import React from 'react';

type PageHeaderProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
};

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  actions,
  className,
}) => {
  return (
    <div className={`mb-4 flex flex-wrap items-center justify-between gap-2 sm:gap-3 ${className ?? ''}`}>
      <div className="min-w-0">
        <h1 className="ui-page-title flex items-center gap-2 [&>svg]:h-6 [&>svg]:w-6 [&>svg]:shrink-0">
          {icon}
          {title}
        </h1>
        {subtitle && <div className="ui-body-sm mt-0.5">{subtitle}</div>}
      </div>
      {actions && <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">{actions}</div>}
    </div>
  );
};

export default PageHeader;
